/**
 * storeKit.js — LEGACY FILE
 *
 * ⚠️  This file is NOT the primary IAP implementation.
 *     The authoritative IAP implementation is: src/services/appleIAP.js
 *     All active code should use appleIAP.js directly.
 *
 * This file uses the old Cordova CDV Purchase v1 window.store API pattern.
 * The current plugin (capacitor-plugin-cdv-purchase@13.x) does NOT expose
 * window.store — it exports `store` as an ES module from appleIAP.js.
 *
 * Functions here are retained for reference only and are guarded to be no-ops
 * if called on a platform without window.store available.
 *
 * BUG FIX (BUG 2 & 8): Added platform guard and no-op stubs to prevent
 * this file from conflicting with appleIAP.js initialization if accidentally called.
 * Product IDs here have been reconciled to match appleIAP.js (authoritative source).
 */

import { Capacitor } from '@capacitor/core';

// The authoritative product ID list — kept in sync with src/services/appleIAP.js
// DO NOT add, remove, or rename these without updating App Store Connect first.
const AUTHORITATIVE_PRODUCT_IDS = [
  // Patient auto-renewable subscriptions
  'com.vivara.healthcare.patient.basic.monthlyv2',
  'com.vivara.healthcare.patient.premium.monthlyv2',
  'com.vivara.healthcare.patient.gold.2monthv2',
  'com.vivara.healthcare.patient.platinum.4monthv2', // 3-month plan; ID is intentionally 4monthv2
  // Pay-per-use consumables
  'com.vivara.healthcare.chat.single',
  'com.vivara.healthcare.voice.single',
  'com.vivara.healthcare.video.single',
  'com.vivara.healthcare.yoga.single',
  // Doctor subscriptions
  'com.vivara.healthcare.doctor.6monthv2',
  'com.vivara.healthcare.doctor.yearlyv2',
  'com.vivara.healthcare.doctor.bluetick.monthly',
  'com.vivara.healthcare.reels.monthly',
  'com.vivara.healthcare.doctor.featured.monthly',
  // Retailer subscriptions
  'com.vivara.healthcare.retailer.6monthv2',
  'com.vivara.healthcare.retailer.bluetick.monthly',
  'com.vivara.healthcare.retailer.featured.monthly',
  // Clinic subscriptions
  'com.vivara.healthcare.clinic.yearlyv2',
  'com.vivara.healthcare.clinic.bluetick.monthly',
  'com.vivara.healthcare.clinic.featured.monthly',
  // Hospital subscriptions
  'com.vivara.healthcare.hospital.yearlyv2',
  'com.vivara.healthcare.hospital.bluetick.monthly',
  'com.vivara.healthcare.hospital.featured.monthly',
];

/**
 * @deprecated Use appleIAP.initialize() from src/services/appleIAP.js instead.
 * This function is a no-op stub retained for backward compatibility.
 */
export const initStoreKit = () => {
  // Guard: Only run on iOS
  if (Capacitor.getPlatform() !== 'ios') return;

  // Guard: window.store is the old Cordova v1 API — not available in cdv-purchase@13.x
  if (!window.store) {
    console.warn(
      '[storeKit.js] window.store is not available. ' +
      'The active IAP implementation is capacitor-plugin-cdv-purchase@13.x (ES module). ' +
      'Use appleIAP from src/services/appleIAP.js instead of this legacy file.'
    );
    return;
  }

  console.warn('[storeKit.js] initStoreKit() is deprecated. Use appleIAP.initialize() instead.');
};

/**
 * @deprecated Use appleIAP.purchase() from src/services/appleIAP.js instead.
 */
export const purchaseStoreKitProduct = (productId) => {
  return Promise.reject(
    new Error(
      '[storeKit.js] purchaseStoreKitProduct() is deprecated. ' +
      'Use appleIAP.purchase() from src/services/appleIAP.js instead.'
    )
  );
};

/**
 * @deprecated Use appleIAP.getProducts() from src/services/appleIAP.js instead.
 */
export const getStoreKitProducts = () => {
  console.warn('[storeKit.js] getStoreKitProducts() is deprecated. Use appleIAP.getProducts() instead.');
  return [];
};

/**
 * @deprecated Use appleIAP.getProduct() from src/services/appleIAP.js instead.
 */
export const getStoreKitProduct = (productId) => {
  console.warn('[storeKit.js] getStoreKitProduct() is deprecated. Use appleIAP.getProduct() instead.');
  return null;
};

/**
 * @deprecated Use appleIAP.restorePurchases() from src/services/appleIAP.js instead.
 */
export const restoreStoreKitPurchases = async () => {
  console.warn('[storeKit.js] restoreStoreKitPurchases() is deprecated. Use appleIAP.restorePurchases() instead.');
};

export { AUTHORITATIVE_PRODUCT_IDS };
